module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumb-bar', {
    attrs: {
      "crumbs": [{
        name: 'Groups'
      }, {
        name: 'Messaging',
        link: 'Messaging Home'
      }, {
        name: 'Message History'
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "portlet light"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [(_vm.massMessages.length > 0 || Object.keys(_vm.serverParams.columnFilters).length !== 0 && _vm.serverParams.columnFilters.constructor === Object) ? _c('div', {
    staticClass: "vue-good-table"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.massMessages,
      "pagination-options": {
        enabled: true,
        perPageDropdown: [10, 20, 50, 100, 200, 500],
        dropdownAllowAll: true,
        perPage: this.serverParams.perPage
      },
      "mode": "remote",
      "totalRows": _vm.totalRecords
    },
    on: {
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange
    },
    scopedSlots: _vm._u([{
      key: "table-column",
      fn: function(props) {
        return [_vm._v("\n                    " + _vm._s(props.column.label) + "\n                  ")]
      }
    }, {
      key: "table-row",
      fn: function(props) {
        return [(props.column.field === 'created_at') ? [_vm._v(_vm._s(props.formattedRow[props.column.field]))] : (props.column.field === 'after') ? [_c('router-link', {
          staticClass: "btn green btn-sm",
          attrs: {
            "to": {
              name: 'Message History Details',
              params: {
                id: props.row.id
              }
            }
          }
        }, [_vm._v("View")])] : [_vm._v(_vm._s(props.formattedRow[props.column.field]))]]
      }
    }], null, false, 3959581935)
  })], 1) : _c('div', {
    staticClass: "not-found-results"
  }, [_c('h4', [_vm._v("No message history found.")])]), _vm._v(" "), _c('router-link', {
    staticClass: "btn green pull-left",
    attrs: {
      "tag": "button",
      "to": {
        name: 'Messaging Home'
      }
    }
  }, [_vm._v("\n                Back\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption caption-md"
  }, [_c('span', {
    staticClass: "caption-subject bold uppercase"
  }, [_vm._v("Message History")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1975d2d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Messaging/History.vue
// module id = 1571
// module chunks = 1